import moment from "moment";
import QuotationDraftService, { quotationDraftErrorMessage } from "@/services/v3/requests/quotation-draft.service";

const MODE_DEFAULT = 'DEFAULT';
const MODE_GROUP = 'GROUP';
const MODE_EXPLICIT = 'EXPLICIT';
const PARTICIPATION_SELLERS = 'SELLERS';

export const quotationDraftSendMixin = {
    data() {
        return {
            draft_svc: new QuotationDraftService(),
            draftId: null,
            draftSent: false,
            draftParticipantsLoaded: false,
        };
    },
    methods: {
        loadDraftParticipants() {
            this.loading = true;
            this.show_sellers = true;

            return this.draft_svc.participants(this.draftId)
                .then(response => response.data.data)
                .then(({ providers, default_selection }) => {
                    this.sellers = this.participantRows(providers, default_selection);
                    this.draftParticipantsLoaded = true;
                    this.filters.check_all = this.sellers.every(row => row.checked);
                })
                .catch(error => this.notifyDraftError(error, 'Não foi possível carregar os fornecedores.'))
                .finally(() => {
                    this.loading = false;
                });
        },
        participantRows(providers, defaultSelection) {
            const keepChecked = !this.ressuply.groups;

            return providers.flatMap(provider => {
                const providerName = provider.trading_name || provider.name;

                if (provider.participation === PARTICIPATION_SELLERS) {
                    return provider.sellers.map(seller => ({
                        key: `seller-${seller.id}`,
                        kind: 'seller',
                        id: seller.id,
                        for_nome: providerName,
                        usu_nome: seller.name,
                        checked: keepChecked && defaultSelection.seller_ids.includes(seller.id),
                        visible: true,
                    }));
                }

                return [{
                    key: `provider-${provider.id}`,
                    kind: 'provider',
                    id: provider.id,
                    for_nome: providerName,
                    usu_nome: 'Sem vendedor (vínculo direto)',
                    checked: keepChecked && defaultSelection.provider_ids.includes(provider.id),
                    visible: true,
                }];
            });
        },
        draftHeaderPayload(keepZeroQuantities = false) {
            return {
                expiration_date: this.ressuply.expiration_date ? moment(this.ressuply.expiration_date).format() : null,
                delivery_type_id: this.ressuply.delivery_type ? this.ressuply.delivery_type.code : null,
                payment_term_id: this.ressuply.payment_type?.ttp_id ?? null,
                payment_mandatory: this.ressuply.payment_mandatory_type ?? false,
                observation: this.ressuply.observation || null,
                is_public: !!this.ressuply.is_public,
                identifier: this.identifier || null,
                keep_zero_quantities: keepZeroQuantities,
            };
        },
        draftSelectionPayload() {
            if (this.ressuply.groups) {
                return { mode: MODE_GROUP, group_ids: [this.ressuply.groups.id] };
            }

            if (!this.draftParticipantsLoaded) {
                return { mode: MODE_DEFAULT };
            }

            const checked = this.sellers.filter(row => row.checked);

            return {
                mode: MODE_EXPLICIT,
                seller_ids: checked.filter(row => row.kind === 'seller').map(row => row.id),
                provider_ids: checked.filter(row => row.kind === 'provider').map(row => row.id),
            };
        },
        sendDraft(keepZeroQuantities = false) {
            this.loading = true;

            return this.draft_svc.update(this.draftId, this.draftHeaderPayload(keepZeroQuantities))
                .then(() => this.draft_svc.saveParticipants(this.draftId, this.draftSelectionPayload()))
                .then(() => this.draft_svc.send(this.draftId))
                .then(() => {
                    this.draftSent = true;
                    this.loading = false;
                    this.close();
                    this.$emit("finish");
                })
                .catch(error => {
                    this.loading = false;
                    this.notifyDraftError(error);
                });
        },
        cancelDraftSend() {
            if (this.draftId && !this.draftSent) {
                this.draft_svc.discard(this.draftId).catch(() => {});
            }

            this.closeDialog();
        },
        notifyDraftError(error, fallback) {
            this.$store.dispatch("notification/add", {
                type: 'error',
                message: quotationDraftErrorMessage(error, fallback),
            });
        },
    },
};
